import { render, staticRenderFns } from "./ObraAdminControls.vue?vue&type=template&id=7af8b71e"
import script from "./ObraAdminControls.vue?vue&type=script&lang=js"
export * from "./ObraAdminControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports